import { isEmpty } from 'lodash'
import { useEffect, useState } from 'react'
const SALESFORCE_URL = process.env.REACT_APP_SALESFORCE_URL || ''
let theiFrame
let form

export const useSalesForceSubmitLead = () => {
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)

  function submitForm(values) {
    console.debug('Submitting to salesforce', values)
    if (!isEmpty(values) && !loading && !success) {
      setLoading(true)
      const customHiddenIframeName = 'JLA_API'
      if (!document.getElementById(customHiddenIframeName)) {
        theiFrame = document.createElement('iframe')
        theiFrame.id = customHiddenIframeName
        theiFrame.name = customHiddenIframeName
        theiFrame.src = 'about:blank'
        theiFrame.style.display = 'none'
        document.body.appendChild(theiFrame)
        values['retURL'] = 'http://127.0.0.1' // dummy URL
        form = document.createElement('form')
        form.method = 'POST'
        form.action = SALESFORCE_URL
        form.setAttribute('target', customHiddenIframeName)
        Object.keys(values).forEach(value => {
          const theInput = document.createElement('input')
          theInput.name = value
          theInput.value = values[value]
          theInput.setAttribute('type', 'hidden')
          form.appendChild(theInput)
        })
        document.body.appendChild(form)
        form.submit()
        setSuccess(true)
        setLoading(false)
      }
      console.debug('Success')
    }
  }

  useEffect(() => {
    return () => {
      if (form && form.parentNode) {
        form.parentNode.removeChild(form)
      }
      if (theiFrame && theiFrame.parentNode) {
        theiFrame.parentNode.removeChild(theiFrame)
      }
    }
  }, [])

  return { loading, submitForm, success }
}
